import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home';
import { environment } from '../environments/environment';

// Import Containers
import {
  FullLayout,
  SimpleLayout
} from './shared/layout/containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayout,
    data: {
      title: 'Home'
    },
    children: [

      {
        path: 'home',
        loadChildren: './home/home.module#HomeModule',
        data: {
          title: 'Boas Vindas',
          showInSidebar: false,
          icon: 'icon-present'
        }
      },
      // {
      //   path: 'assinador',
      //   loadChildren: './assinador/assinador.module#AssinadorModule',
      //   data: {
      //     title: 'Exemplo Angular',
      //     showInSidebar: true,
      //     icon: 'icon-present'
      //   }
      // },
      {
        path: 'assinartextocliente',
        loadChildren: './assinartextocliente/assinartextocliente.module#AssinarTextoClienteModule',
        data: {
          title: 'Assinar Texto',
          showInSidebar: true,
          icon: 'icon-note'
        }
      },
      {
        path: 'assinarformulario',
        loadChildren: './assinarformulario/assinarformulario.module#AssinarFormularioModule',
        data: {
          title: 'Assinar Formulário',
          showInSidebar: true,
          icon: 'icon-docs'
        }
      },
      {
        path: 'arquivonoservidor',
        loadChildren: './arquivonoservidor/arquivonoservidor.module#ArquivoNoServidorModule',
        data: {
          title: 'Assinar Arquivo',
          showInSidebar: true,
          icon: 'icon-folder-alt'
        }
      },
      {
        path: 'assinadorpdf',
        loadChildren: './assinadorpdf/assinadorpdf.module#AssinadorPdfModule',
        data: {
          title: 'Assinar PDF',
          showInSidebar: true,
          icon: 'icon-notebook'
        }
      },
      {
        path: 'minimalista',
        component: HomeComponent,
        resolve: {
          url: 'externalUrlRedirectResolver'
        },
        data: {
          externalUrl: environment.minimalistUrl,
          title: 'Exemplo Minimalista',
          showInSidebar: true,
          icon: 'icon-link'
        }
      }
      // {
      //   path: 'neoid',
      //   loadChildren: './neoid/neoid.module#NeoIDModule',
      //   data: {
      //     title: 'NeoID',
      //     showInSidebar: true,
      //     icon: 'fas fa-cloud'
      //   }
      // }
    ]
  },
  {
    path: '',
    component: SimpleLayout,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: 'login',
        loadChildren: './auth/login/login.module#LoginModule',
      },
      {
        path: 'amnesia',
        loadChildren: './auth/amnesia/amnesia.module#AmnesiaModule',
      },
      {
        path: 'register',
        loadChildren: './auth/register/register.module#RegisterModule',
      }
    ]
  }
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/fabiano/git/assinador-showcase/frontend/src/app/app-routing.module.ts